import { useEffect } from 'react'

import { Select } from '../Select'
import { useAsyncSelectStates } from '../Select.hooks'
import { SelectDropdownAsyncList } from '../SelectDropdownAsyncList'

function InputAsyncSelect({
  Control,
  EntityIcon,
  apiParams,
  blocked,
  checkIsLastPage,
  closeDropdownOnClear,
  controlProps,
  disabled,
  dropdownFloatingConfig,
  dropdownProps,
  error,
  getApiParamsLoadNext,
  getData,
  getDataItems,
  getPermissionsData,
  getSearchApiParam,
  getShowSelectedApiParam,
  initialItems,
  initialSearchValue,
  listProps,
  loadAllApiParams,
  maxLength,
  minSearchLength,
  multi,
  observerOptions,
  pagination,
  selectStatesRef,
  thresholdEndIndex,
  toPreparedItems,
  value,
  onChangeSearch,
  onClear,
  onCloseDropdown,
  onSelectAll,
  onSelectItem,
  ...restProps
}) {
  const selectStates = useAsyncSelectStates({
    apiParams,
    blocked,
    checkIsLastPage,
    disabled,
    dropdownFloatingConfig,
    getApiParamsLoadNext,
    getData,
    getDataItems,
    getPermissionsData,
    getSearchApiParam,
    getShowSelectedApiParam,
    initialItems,
    initialSearchValue,
    loadAllApiParams,
    maxLength,
    minSearchLength,
    multi,
    observerOptions,
    pagination,
    thresholdEndIndex,
    toPreparedItems,
    value,
    onChangeSearch,
    onCloseDropdown,
    onSelectAll,
    onSelectItem,
  })

  useEffect(() => {
    if (selectStatesRef) {
      selectStatesRef.current = selectStates
    }
  }, [selectStates])

  const {
    activeIndex,
    context,
    elementsRef,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    getThresholdItemProps,
    handleChangeSearch,
    handleClearSearch,
    handleClose,
    handleKeyDown,
    handleOpen,
    handleSelect,
    handleSelectAll,
    handleToggleOpen,
    handleToggleShowSelected,
    isOpen,
    loadingInitial,
    loadingMore,
    options,
    refs,
    searchValue,
    showSelected,
  } = selectStates

  return (
    <Select
      {...restProps}
      Control={Control}
      List={SelectDropdownAsyncList}
      activeIndex={activeIndex}
      contextProps={{
        EntityIcon,
        blocked,
        closeDropdownOnClear,
        disabled,
        error,
        getFloatingItemProps,
        multi,
        searchValue,
        showSelected,
        value,
        onChangeSearch: handleChangeSearch,
        onClear,
        onClearSearch: handleClearSearch,
        onClose: handleClose,
        onOpen: handleOpen,
        onSelect: handleSelect,
        onSelectAll: handleSelectAll,
        onToggleOpen: handleToggleOpen,
        onToggleShowSelected: handleToggleShowSelected,
      }}
      controlProps={{
        ...controlProps,
        ...getReferenceProps({ disabled, onKeyDown: handleKeyDown }),
      }}
      dropdownProps={{
        ...dropdownProps,
        context,
        floatingStyles,
        getFloatingProps,
      }}
      isOpen={isOpen}
      listProps={{
        ...listProps,
        elementsRef,
        getThresholdItemProps,
        headerProps: {
          ...listProps?.headerProps,
          Search: listProps?.headerProps?.Search ?? null,
        },
        loadingInitial,
        loadingMore,
        moreItemsLoaderProps: {
          ...listProps?.moreItemsLoaderProps,
          hasText: true,
        },
      }}
      options={options}
      refs={refs}
    />
  )
}

export default InputAsyncSelect
